// extracted by mini-css-extract-plugin
module.exports = {"ceo":"styles_ceo__dniOw","icon":"styles_icon__tC_C9","statement":"styles_statement__8KGOD","ceo_name":"styles_ceo_name__fVosw","right_section":"styles_right_section__E84T3"};